import BaseTooltip from 'components/BaseTooltip'
import { TemporalEntityId } from 'entities-next/common'
import { FundingRound, Investment } from 'entities-next/fundingRounds'
import React from 'react'
import { useTabs } from 'scenes/Dashboard/components-next/Tabs/'
import { makeStyles } from 'tss-react/mui'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { Tab, Tabs, Theme } from '@mui/material'

import { FundingRoundForm } from './components/FundingRoundForm'
import { FundingRoundInvestmentForm } from './components/FundingRoundInvestmentForm'

export type FundingRoundEditProps = ExtendableStyles &
  Testable & {
    data: FundingRound
    onUpdate: (data: FundingRound) => Promise<any> | any
    onUpdateInvestments: (data: Investment[]) => Promise<any> | any
    onDelete: () => any
  }

export function FundingRoundEdit({
  onUpdate,
  onUpdateInvestments,
  onDelete,
  data,
  ...otherProps
}: FundingRoundEditProps) {
  const { classes } = useStyles()
  const [tabValue, handleTabChange] = useTabs(FundingRoundFormView.data)
  const isFundingRoundSaved = data.id !== TemporalEntityId.new

  const renderTabWithTooltip = (children: React.ReactElement, title: string) => (
    <BaseTooltip wrapped bottom title={title}>
      {children}
    </BaseTooltip>
  )

  const investmentTab = (
    <Tab value={FundingRoundFormView.investments} label={'Investments'} disabled={!isFundingRoundSaved} />
  )

  return (
    <div {...otherProps}>
      <Tabs value={tabValue} onChange={handleTabChange}>
        <Tab value={FundingRoundFormView.data} label="Funding round data" />
        {isFundingRoundSaved
          ? investmentTab
          : renderTabWithTooltip(investmentTab, 'You need to save the funding round data first')}
      </Tabs>
      {tabValue === FundingRoundFormView.data && (
        <FundingRoundForm onUpdate={onUpdate} onDelete={onDelete} data={data} className={classes.content} />
      )}
      {tabValue === FundingRoundFormView.investments && (
        <FundingRoundInvestmentForm className={classes.content} onUpdate={onUpdateInvestments} data={data} />
      )}
    </div>
  )
}

enum FundingRoundFormView {
  data = 'data',
  investments = 'investments',
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  content: {
    width: '100%',
    marginTop: spacing(2),
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginTop: spacing(3),
  },
  actionButtons: {
    marginLeft: spacing(2),
  },
}))
